module.exports = __webpack_public_path__ + "img/pg4.c75e4add.png";